import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import ApiController from "../../controller/ApiController";
import { langState, langText } from "../../recoil/lang";
import { RequestReviewType } from "../../recoil/socket";
import "../../styles/CustomModal.css";
import LogController from "../../controller/LogController";

const RatingModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  ratingInfo: RequestReviewType | null;
  setRatingInfo: (ratingInfo: RequestReviewType | null) => void;
}) => {
  const onCloseModal = () => {
    oProps.setVisible(false);
    oProps.setRatingInfo(null);
    LogController.click({
      path: "RatingModal",
      params: "rating",
      params2: "사용자가 리뷰 모달 닫음",
    });
  };

  const [lang, setLang] = useRecoilState<number>(langState);
  const [foodRating, setFoodRating] = useState<number>(5);
  const [deliveryRating, setDeliveryRating] = useState<number>(5);
  const [review, setReview] = useState<string>("");

  useEffect(() => {
    if (oProps.isVisible) {
      LogController.event({
        path: "RatingModal",
        params: "rating",
        params2: "리뷰 모달 열림",
      });
    }
  }, [oProps.isVisible]);

  // API 호출
  const sendReview = async () => {
    try {
      if (oProps.ratingInfo !== null) {
        const oParams = {
          order_id: oProps.ratingInfo.order_id,
          order_seq: oProps.ratingInfo.order_seq,
          store_id: oProps.ratingInfo.store_id,
          parent_store_id: oProps.ratingInfo.parent_store_id,
          food_score: foodRating,
          delivery_score: deliveryRating,
          content: review,
        };
        const oRes: any = await ApiController.order.setReview(oParams);

        if (oRes && oRes.data) {
          console.log("setReview", oRes.data);
          if (oRes.data.success) {
            oProps.setRatingInfo(null);
            LogController.event({
              path: "RatingModal",
              params: "rating",
              params2: `${oProps.ratingInfo.order_id} 주문 리뷰 등록 완료`,
            });
          } else {
            LogController.api({
              path: "RatingModal",
              params: "rating",
              params2: `/order/setReview ${oProps.ratingInfo.order_id} 주문 리뷰 실패`,
            });
          }
        }
      }
      oProps.setVisible(false);
    } catch (err) {
      console.log("err-->", err);
    }
  };

  useEffect(() => {
    setDeliveryRating(5);
    setFoodRating(5);
    setReview("");

    if (oProps.isVisible) {
      LogController.event({
        path: "RatingModal",
        params: "rating",
        params2: "리뷰 모달 열림",
      });
    }
  }, [oProps.isVisible]);

  return (
    <Modal
      isOpen={oProps.isVisible}
      onRequestClose={onCloseModal}
      className="ratingModal modal-content bottom"
      closeTimeoutMS={100}
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
    >
      <Style>
        <div className="modal">
          <div className="centerWrap">
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check_green.svg`}
              alt="ic"
            />
            <p className="titleFont">{langText.ratingModal_title[lang]}</p>
            <img
              className="closeIcon"
              onClick={onCloseModal}
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close_black.svg`}
              alt="ic"
            />
          </div>
          <div className="ratingBox">
            <div className="title">
              {langText.ratingModal_title_rating[lang]}
            </div>
            <div className="content">
              <div className="row">
                <p>{langText.ratingModal_delivery_rating[lang]}</p>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star.svg`}
                  alt="ic"
                  onClick={() => setDeliveryRating(1)}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    deliveryRating < 2 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setDeliveryRating(2)}
                  alt="ic"
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    deliveryRating < 3 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setDeliveryRating(3)}
                  alt="ic"
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    deliveryRating < 4 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setDeliveryRating(4)}
                  alt="ic"
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    deliveryRating < 5 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setDeliveryRating(5)}
                  alt="ic"
                />
              </div>
              <div className="row">
                <p>{langText.ratingModal_food_rating[lang]}</p>
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star.svg`}
                  alt="ic"
                  onClick={() => setFoodRating(1)}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    foodRating < 2 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setFoodRating(2)}
                  alt="ic"
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    foodRating < 3 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setFoodRating(3)}
                  alt="ic"
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    foodRating < 4 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setFoodRating(4)}
                  alt="ic"
                />
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star${
                    foodRating < 5 ? "_inactive" : ""
                  }.svg`}
                  onClick={() => setFoodRating(5)}
                  alt="ic"
                />
              </div>
              <textarea
                value={review}
                placeholder={langText.ratingModal_placeholder[lang]}
                autoFocus={false}
                onChange={(e) => setReview(e.target.value)}
              />
            </div>
          </div>

          <div className="confirmButton" onClick={sendReview}>
            {langText.button_confirm[lang]}
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default RatingModal;

const Style = styled.div`
  .modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 8% 6%;
    gap: 30px;
    width: 100%;
    position: relative;
  }

  .centerWrap {
    text-align: center;
  }

  .titleFont {
    margin-top: 20px;
    font-size: 20px;
    line-height: 28px;
    font-weight: 400;
    color: #000000;
    text-align: center;
  }

  .closeIcon {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 40px;
  }

  .row {
    padding-bottom: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ratingBox {
    width: 90%;

    .title {
      background: #4d4d4d;
      border: 1px solid #4d4d4d;
      color: #ffffff;
      font-size: 18px;
      line-height: 40px;
      font-weight: 400;
      text-align: center;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    .content {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      border: 1px solid #d1d1d1;
      padding: 14px 18px;
      height: 90%;
      text-align: center;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;

      p {
        width: 30%;
        color: #000000;
        font-size: 18px;
        line-height: 36px;
        font-weight: 400;
        margin: 0 0;
        padding-right: 8px;
      }
    }

    textarea {
      margin-top: 10px;
      display: flex;
      align-items: center;
      width: 100%;
      height: 100px;
      background: #f3f3f3;
      border: none;
      padding: 12px 16px;
      border-radius: 10px;
      font-size: 16px;
      font-weight: 300;
    }
  }

  .confirmButton {
    width: 90%;
    padding: 16px;
    background: #4dd2ae;
    font-size: 24px;
    line-height: 32px;
    border-radius: 10px;
    color: #ffffff;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
  }

  @media (max-width: 700px) {
    .modal {
      padding: 8%;
      padding-top: 12%;
      gap: 20px;
    }

    .closeIcon {
      width: 24px;
      right: 12px;
      top: 12px;
    }

    .titleFont {
      margin-top: 10px;
      font-size: 16px;
      line-height: 22px;
      font-weight: 500;
    }

    .row {
      padding-bottom: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 32px;
        height: 32px;
      }
    }

    .ratingBox {
      width: 100%;

      .title {
        font-size: 12px;
        line-height: 32px;
        border-radius: 8px 8px 0 0;
      }
      .content {
        padding: 12px;
        height: 90%;
        text-align: center;
        border-radius: 0 0 8px 8px;

        p {
          font-size: 14px;
          line-height: 20px;
          padding: 0px;
        }
      }

      textarea {
        margin-top: 6px;
        min-height: 80px;
        height: 50%;
        padding: 16px 12px;
        border-radius: 8px;
        font-size: 12px;
      }
    }

    .confirmButton {
      width: 100%;
      padding: 10px;
      font-size: 20px;
    }
  }
`;
